import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import { ThemeProvider, Button as Button$1 } from "@mui/material";
import { EXTRA_LARGE, LARGE } from "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../hooks/useFilterEmployees/useFilterEmployees.js";
import "lodash/debounce.js";
import { useResponsive } from "../../../../../hooks/useResponsive.js";
import "../../../../../themes/typography/typography.js";
import "color-alpha";
import { ExternalTheme } from "../../../../../themes/external-theme/external-theme.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/shadows/shadows.js";
import { adjustable } from "./styles.js";
import "../../../../../type/Translations.js";
import "../../../../../type/Employee.js";
import "../../../../../utils/array.js";
import "fast-memoize";
import "../../../../../utils/employee/getUniqueByRoles.js";
import "lodash/reverse.js";
import "lodash/uniqBy.js";
import "lodash";
import "../../../smileview-section/hooks/useWindowSize.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
const Button = ({
  size = EXTRA_LARGE,
  adjustable: adjustable$1 = false,
  children,
  onClick,
  sx,
  color,
  dataTestId,
  ...rest
}) => {
  const [shouldTrigger, setShouldTrigger] = useState(true);
  const { isDesktop } = useResponsive();
  const isNotDesktop = !isDesktop;
  const buttonSize = isNotDesktop && size === EXTRA_LARGE ? LARGE : size;
  const handleInteraction = (event) => {
    if (onClick && shouldTrigger) {
      onClick(event);
      setShouldTrigger(false);
    }
  };
  const onTouchStart = () => {
    setShouldTrigger(true);
  };
  const onTouchMove = () => {
    setShouldTrigger(false);
  };
  return /* @__PURE__ */ jsx(ThemeProvider, { theme: ExternalTheme, children: /* @__PURE__ */ jsx(
    Button$1,
    {
      disableRipple: true,
      onTouchStart,
      onTouchMove,
      onTouchEnd: handleInteraction,
      size: buttonSize,
      onClick,
      "data-testid": dataTestId,
      color,
      sx: [adjustable$1 && adjustable, ...Array.isArray(sx) ? sx : [sx]],
      ...rest,
      children
    }
  ) });
};
export {
  Button
};
